import React from 'react';
import PropTypes from 'prop-types';

import UserDetailsRow from './userDetailsRow';

const UserDetails = ({ profile, labels }) => {
  const concatStrings = (acc, val) => (acc ? `${acc}, ${val.name}` : val.name);
  const arrayToString = arr => arr.reduce(concatStrings, '');
  const {
    USERS: {
      FORM: { LABEL }
    }
  } = labels;
  const {
    first_name: firstName,
    last_name: lastName,
    email,
    provinces,
    role,
    adt_rep_id: adtRepId,
    channels,
    channel_org_code: channelOrgCode,
    outlet,
    outlet_code: outletCode,
    dealership,
    sales_manager: salesManager,
    sales_manager_email: salesManagerEmail,
    sales_rep_id: salesRepId,
    xid
  } = profile;
  const userData = {
    FIRST_NAME: firstName,
    LAST_NAME: lastName,
    EMAIL: email,
    PROVINCE: arrayToString(provinces),
    ROLE: role && role.description,
    ADT_REP_ID: adtRepId,
    CHANNEL: arrayToString(channels),
    CHANNEL_ORGANIZATION_CODE: channelOrgCode,
    OUTLET: outlet,
    OUTLET_CODE: outletCode,
    DEALERSHIP: dealership && dealership.description,
    SALE_MANAGER: salesManager,
    SALE_MANAGER_EMAIL: salesManagerEmail,
    SALE_REP_ID: salesRepId,
    XID: xid
  };
  const userRow = key => (
    <UserDetailsRow label={LABEL[key]} value={userData[key]} />
  );

  return Object.keys(userData).map(userRow);
};

UserDetails.propTypes = {
  profile: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    role: PropTypes.object,
    channel: PropTypes.object,
    province: PropTypes.string
  }).isRequired,
  labels: PropTypes.shape({
    USERS: PropTypes.object
  }).isRequired
};

export default UserDetails;
